// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__AyJgP","iconFont":"Icon_iconFont__X5xY-"};